module.exports = __webpack_public_path__ + "media/images/home/tagline-bg-ef836bcf82dca0cbada6cfc1fd2eba40.jpg";